<p-dialog
  data-testid="approval-details-dialog"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="dialogStyle()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="config?.title | translate"
>
  <!-- Header Information Section -->
  <div class="px-4">
    <div class="header-info-section">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="flex flex-col">
          <label class="info-label">
            {{ "synchronization.table.columns.data_sync_number" | translate }}
          </label>
          <span class="info-value">
            {{ synchronizationData?.adjustCode || "-" }}
          </span>
        </div>
        <div class="flex flex-col">
          <label class="info-label">
            {{ "synchronization.table.columns.warehouse_name" | translate }}
          </label>
          <span class="info-value">
            {{ synchronizationData?.warehouseName || "-" }}
          </span>
        </div>
        <div class="flex flex-col">
          <label class="info-label">
            {{ "synchronization.table.columns.warehouse_code" | translate }}
          </label>
          <span class="info-value">
            {{ synchronizationData?.warehouseCode || "-" }}
          </span>
        </div>
      </div>
    </div>

    <app-data-table
      data-testid="approval-details-dialog-table"
      [dataSource]="adjustmentDetails"
      [columns]="config?.tableColumns || []"
      [loading]="loading"
      [hasCheckColumn]="false"
      [getFieldError]="getFieldError.bind(this)"
      [rows]="20"
      [first]="0"
      [totalRecords]="adjustmentDetails.length"
      (cellValueChange)="onCellValueChange($event)"
      scrollHeight="550px"
    >
      <!-- Custom Template for Adjustment Type -->
      <ng-template #customTemplate let-value let-column="column">
        @if (column.prop === "adjustmentType") {
          <span
            class="flex justify-center items-center px-2 py-1 rounded-full text-xs font-medium"
            [class]="getAdjustmentTypeClass(value)"
          >
            {{ getAdjustmentTypeText(value) }}
          </span>
        } @else {
          {{ value }}
        }
      </ng-template>
    </app-data-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        data-testid="approval-details-dialog-cancel-btn"
        [label]="'common.actions.cancel' | translate"
        severity="secondary"
        outlined="true"
        size="small"
        (onClick)="onCancel()"
        [disabled]="loading"
        styleClass="text-sm px-4 py-2"
      />
      <p-button
        data-testid="approval-details-dialog-reject-btn"
        [label]="'synchronization.actions.reject' | translate"
        severity="danger"
        outlined="true"
        size="small"
        (onClick)="onReject()"
        [disabled]="loading"
        styleClass="text-sm px-4 py-2"
      />
      <p-button
        data-testid="approval-details-dialog-approve-btn"
        [label]="'synchronization.actions.approve' | translate"
        severity="primary"
        size="small"
        (onClick)="onApprove()"
        [disabled]="loading"
        styleClass="text-sm px-4 py-2"
      />
    </div>
  </ng-template>
</p-dialog>
